interface BrowserFrameProps {
	size?: "lg" | "sm";
}

/** Traffic-light browser chrome bar, in a large (hero) or small (device preview) size. */
function BrowserFrame(prop: BrowserFrameProps) {
	const { size = "lg" } = prop;
	if (size === "sm") {
		return (
			<div className="flex h-6 items-center gap-1.5 border-b border-border bg-bg/70 px-3">
				<span className="h-2 w-2 rounded-full bg-danger/70" />
				<span className="h-2 w-2 rounded-full bg-warning/70" />
				<span className="h-2 w-2 rounded-full bg-success/70" />
				<span className="ms-2 h-2 flex-1 rounded-full bg-muted/15" />
			</div>
		);
	}
	return (
		<div className="flex h-10 items-center gap-2 border-b border-border bg-bg/70 px-4">
			<span className="h-3 w-3 rounded-full bg-danger/70" />
			<span className="h-3 w-3 rounded-full bg-warning/70" />
			<span className="h-3 w-3 rounded-full bg-success/70" />
			<span className="ms-3 h-4 flex-1 rounded-full bg-muted/15" />
		</div>
	);
}

export default BrowserFrame;
